export enum EventCategory {
    Core = 'CORE',
    Extra = 'EXTRA'
}